$(function() {

    var footerSearchForm = $('#footerSearchForm');

    if(footerSearchForm) {
         $('#footerSearchForm').on('submit',function(){
             return $('#footer-search-request').val().length >= 3;
         })
    }

    var $searchForm = $('#search-form');

    if ($searchForm.length) {
        var $result = $('#result'),
            $noResults = $('#no-results'),
            $resultChild = $result.children(),
            $resultTemplate = $resultChild.find('.template'),
            $resultBySections = $('#result-by-sections'),
            $resultsFound = $('#results-found'),
            $sectionTemplate = $resultBySections.find('.template'),
            $blocksToShow,
            sectionsCount = {},
            requestText,
            prevRequestText,
            $resultItem,
            $totalCount;

        function filterResults() {
            var $this = $(this);
            $resultBySections.find('.active').removeClass('active');
            
            if ($this.hasClass('section-mark')) {
                $resultBySections.find('[href="' + $this.attr('href') + '"]').addClass('active');
            } else {
                $this.addClass('active')
            }

            $resultItem.each(function(i, item) {
                var $item = $(item),
                    sectionId = $this.data('section');
                    
                if (sectionId == 0) {
                    showItem($item, true);
                } else {

                    if ($item.hasClass('from-section-' + sectionId)) {
                        showItem($item);
                    } else {
                        hideItem($item);
                    }

                }

            });
            
            $totalCount.text($this.data('count'));
        }

        function showItem($item, immediate) {
            
            if (!$item.is(':visible')) {
                setTimeout(function() {$item.slideDownFadeIn(transitionDuration)}, (immediate) ? 0 : transitionDuration);
            }

        }

        function hideItem($item) {
            
            if ($item.is(':visible')) {
                $item.fadeOutSlideUp(transitionDuration);
            }

        }

        function showError() {
            $('#search-error').fadeIn();
        }

        $searchForm.on('submit', function(e) {
            e.preventDefault();
            requestText = $.trim($('#search-request').val());

            if (requestText && requestText != prevRequestText) {
                $searchForm.addClass('sending');
                $resultChild.empty().append($resultTemplate);
                $resultBySections.empty().append($sectionTemplate);
                $noResults.add($resultsFound).fadeOut(transitionDuration);

                $.ajax({
                    url: $searchForm.data('api'),
                    data: $searchForm.serialize(),
                    dataType: 'json',
                    complete: function() {
                        $searchForm.removeClass('sending');
                    },
                    success: function(res) {

                        if (res.status !== 'ok') {
                            showError();
                            return;
                        }

                        var requestParts = res.searchWords.split(/[., -]/),//for bolding all matchings
                            searchRegExpString = '';
                        sectionsCount = {'0': 0};
                        $.each(requestParts, function() {
                            searchRegExpString = (searchRegExpString) ? searchRegExpString + '|' + this : this;
                        });
                        var searchRegExp = new RegExp(res.searchWords + '|' + searchRegExpString,'gi');
                        
                        $.each(res.all, function(i, item) {
                            // console.log(i, item);
                            $resultChild.append(
                                $resultTemplate.clone()
                                            .removeClass('template')
                                            .addClass('from-section-' + item.id)
                                            .find('.link').attr('href', item.href).end()
                                            .find('h3').text(item.title).end()
                                            .find('p').html(item.fragment.replace(searchRegExp, '<b>$&</b>')).end()
                                            .find('.badge').text(res.sections[item.id])
                                                        .addClass('badge-' + item.id)
                                                        .data('count', sectionsCount[item.id])
                                                        .data('section', item.id)
                                                        .attr('href', '#' + item.id)
                                                        .on('click', filterResults)
                                                        .end()
                            );
                            sectionsCount[item.id] = (sectionsCount[item.id]) ? sectionsCount[item.id] + 1 : 1;
                        });
                        $.each(sectionsCount, function(key, val) {
                            sectionsCount[0] += val;
                        });
                        $resultItem = $result.find('.result-item:not(.template)');
                        $totalCount = $('#total-count')
                        $.each(sectionsCount, function(key, val) {
                            $resultBySections.append(
                                $sectionTemplate.clone()
                                                .removeClass('template')
                                                .find('.title').text(res.sections[key]).end()
                                                .find('.count').text(val).end()
                                                .find('a').data('section', key)
                                                        .data('count', val)
                                                        .attr('href', '#' + key)
                                                        .addClass('filter-' + key)
                                                        .on('click', filterResults)
                                                        .end()
                            );
                        });
                        $totalCount.text(sectionsCount[0]);

                        if (res.count) {
                            $blocksToShow = $resultBySections.add($resultsFound).add($result);
                        } else {
                            $blocksToShow = $resultBySections.add($resultsFound).add($noResults.find('.search-request').text(requestText).end());
                        }

                        $blocksToShow.fadeIn(transitionDuration);

                        if (!prevRequestText && locationHash) {//so it's by direct link with hash
                            var $filterLink = $('.filter-' + locationHash.slice(1));

                            if ($filterLink.length) {
                                $filterLink.click();
                            }

                        }
                        
                        if (prevRequestText && window.history) {
                            window.history.pushState({'s': requestText}, requestText, '?qs=' + requestText);
                        }

                        prevRequestText = requestText;
                    },
                    error: function(e) {
                        showError();
                    }
                });
            }

                // res = 
                // 	{
                // 		"status":"ok",
                // 		"actualLang":"en",
                // 		"statusDescription":"",
                // 		"all":[{"href":"https://www.dukascopy.com/swiss/english/marketwatch/market_news/Geneva-Airport/","title":"Geneva Airport","fragment":"Jay Clayton, the Chairman of the US Securities and Exchange Commission, said on Thursday that he was worried about the negative interest rate and the healthu00a0...","id":"0"},{"href":"https://www.dukascopy.com/swiss/english/about/company-structure/","title":"Company Structure","fragment":"Executive Committee A. Duka (co-Chairman, co-CEO 1-CTO 2), V. Duka (co- Chairman, co-CEO-CAO 3), L. Bellieres (CRO 4), I. Kupriyanova (CFO 5),u00a0...","id":"2038"},{"href":"https://www.dukascopy.com/swiss/english/marketwatch/market_news/Market-News-and-Research/122002/","title":"Market News and Research","fragment":"7 days ago u00b7 On Monday, the commodity price was testing the resistance of the 55, 100 and 200-hour simple moving averages and a monthly pivot point atu00a0...","id":"2038"},{"href":"https://www.dukascopy.com/swiss/english/marketwatch/market_news/Fundamental-Analysis/121851/","title":"Fundamental Analysis","fragment":"9 Oct 2019 u00b7 The European Common Currency traded sideways against the US Dollar, following the US PPI data release on Tuesday at 12:30 GMT.","id":"3597"},{"href":"https://www.dukascopy.com/swiss/english/about/press-release/","title":"In the Press - Dukascopy Bank SA | Swiss Forex Bank | ECN Broker ...","fragment":"The FX bank yielded a profit of $1.07 million (CHF 1.05 million) compared to an operating loss of CHF 41,137. Web Site: financemagnates.comu00a0...","id":"4684"},{"href":"https://www.dukascopy.com/swiss/english/about/callback/","title":"Call-Back Request","fragment":"Trading Fees u00b7 Rollover conditions u00b7 Volume Trading Commission Discount Program u00b7 SMS notification service fees u00b7 Wealth management (LP PAMM) fees andu00a0...","id":"4684"},{"href":"https://www.dukascopy.com/swiss/english/marketwatch/market_news/Market-News-and-Research/120118/","title":"Market News and Research","fragment":"12 Aug 2019 u00b7 On Monday, the GBP/USD began a surge that was caused by meeting the historical low level at 1.2020. By the middle of London\'s tradingu00a0...","id":"4684"},{"href":"https://www.dukascopy.com/swiss/english/about/ournews/?page=9","title":"Company News","fragment":"16 Aug 2018 u00b7 The company invites back former Alpari Japan customers with a \"Welcome back!\" campaign, which grants a 50% commission discount for 3u00a0...","id":"4684"},{"href":"https://www.dukascopy.com/swiss/english/about/issues/","title":"Report an Issue","fragment":"Your opinion is important for us. If there is any issue with the services provided by Dukascopy (trading/technical issue, unprecise info delivery, etc.), please notifyu00a0...","id":"4684"},{"href":"https://www.dukascopy.com/swiss/english/marketwatch/market_news/Trading-Ideas/122003/","title":"Trading Ideas","fragment":"7 days ago u00b7 The DUK+/EUR rate bounced off the combined support of the 0.6500 mark and the first support level of the simple monthly pivot points atu00a0...","id":"4684"}],
                // 		"sections":{
                // 			"0": "Other",
                // 			"2038": "B2B",
                // 			"4684": "Market Info",
                // 			"3597": "Forex Trading"
                // 		}
                // 	};
        });
        $('#search-form').submit();
    }
});